import { stripTags } from '~/composables/util'
import { useControlPanelStore } from '~/store/control-panel'

export default defineNuxtPlugin((nuxtApp) => {
  const controlPanelStore = useControlPanelStore()

  if (controlPanelStore?.isEnabled('translations')) {
    nuxtApp.vueApp.config.globalProperties.$i18n.postTranslation = (translation: string, key: string) => {
      // Use different color when the key is not translated
      const color = translation === key ? '#660000' : '#006633'

      console.debug(
        `%c${stripTags(translation)}%c\n${key}`,
        `border-left: 2px solid ${color}; color: ${color}; padding-left: 5px; font-family: Arial`,
        `border-left: 2px solid ${color}; color: ${color}; padding-left: 5px`,
      )

      // Wrap the translation with `{` and `}`
      // Note that we first split on `|` to also properly wrap cases such as 'none | one | {n} items'
      return translation
        .split('|')
        .map((part) => `{${part.trim()}}`)
        .join(' | ')
    }
  }
})
